import 'researcher/digital-orders/styles/digital-orders.scss';
import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import IdentifyPage from 'researcher/application/components/IdentifyPage';
import { TYPE_TRANSLATION } from 'researcher/digital-orders/constants';
import Redirect from 'shared/components/Redirect';
import { useTranslate } from 'shared/helper/translate';
import AvailableDigitalTranslationPurchasesFeatures from './AvailableDigitalTranslationPurchasesFeatures';
import DigitalTranslationsHeader from './DigitalTranslationsHeader';
import DigitalTranslationsInstructions from './DigitalTranslationsInstructions';
import DigitalTranslationsOverview from './DigitalTranslationsOverview';
import DigitalTranslationsSidebar from './DigitalTranslationsSidebar';
import ManageDigitalTranslations from './ManageDigitalTranslationsContainer';
var DigitalTranslations = function DigitalTranslations(_ref) {
  var accessType = _ref.accessType,
    allowsDigitalTranslations = _ref.allowsDigitalTranslations,
    digitalPurchases = _ref.digitalPurchases,
    digitalTranslationsEnabled = _ref.digitalTranslationsEnabled,
    digitalTranslationsSurveyUrl = _ref.digitalTranslationsSurveyUrl,
    displayDigitalTranslationsResults = _ref.displayDigitalTranslationsResults,
    fileIdentity = _ref.fileIdentity,
    location = _ref.location,
    numberOfUsesAvailable = _ref.numberOfUsesAvailable,
    hasAvailableDigitalTranslationPurchases = _ref.hasAvailableDigitalTranslationPurchases,
    page = _ref.page,
    searchDigitalOrders = _ref.searchDigitalOrders,
    status = _ref.status,
    uuid = _ref.uuid,
    wordCountExceeded = _ref.wordCountExceeded,
    isCurieLaunched = _ref.isCurieLaunched;
  if (isCurieLaunched) {
    return /*#__PURE__*/React.createElement(Navigate, {
      to: "/rubriq/translation",
      replace: true
    });
  }
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  useEffect(function () {
    if (allowsDigitalTranslations) {
      searchDigitalOrders({
        page: page,
        type: TYPE_TRANSLATION
      });
    }
  }, []);
  if (!allowsDigitalTranslations) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: "/researcher"
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "container digital-translations"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row my-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement(DigitalTranslationsHeader, {
    busy: status.searchBusy,
    numberOfUsesAvailable: numberOfUsesAvailable
  }), allowsDigitalTranslations ? /*#__PURE__*/React.createElement(DigitalTranslationsInstructions, {
    accessType: accessType
  }) : null)), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-8 col-12"
  }, /*#__PURE__*/React.createElement(IdentifyPage, {
    bodyClassName: "bg-gray-lighter",
    title: t('digital-translations')
  }), displayDigitalTranslationsResults ? /*#__PURE__*/React.createElement(ManageDigitalTranslations, {
    fileIdentity: fileIdentity,
    location: location,
    wordCountExceeded: wordCountExceeded
  }) : /*#__PURE__*/React.createElement(DigitalTranslationsOverview, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4 col-12 position-relative"
  }, displayDigitalTranslationsResults ? /*#__PURE__*/React.createElement(DigitalTranslationsSidebar, {
    accessType: accessType,
    digitalPurchases: digitalPurchases,
    digitalTranslationsEnabled: digitalTranslationsEnabled,
    digitalTranslationsSurveyUrl: digitalTranslationsSurveyUrl,
    numberOfUsesAvailable: numberOfUsesAvailable,
    uuid: uuid
  }) : null, !digitalTranslationsEnabled ? /*#__PURE__*/React.createElement(AvailableDigitalTranslationPurchasesFeatures, {
    hasAvailableDigitalTranslationPurchases: hasAvailableDigitalTranslationPurchases
  }) : null))));
};
export default DigitalTranslations;